export { AccordionPanelComponent } from './accordion-group.component';
export { AccordionComponent } from './accordion.component';
export { AccordionModule } from './accordion.module';
export { AccordionConfig } from './accordion.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/accordion/index.js
// module id = ../../../../ng2-bootstrap/accordion/index.js
// module chunks = 4